export const projectDeploymentAnimation = {
  options: {
    path: 'assets/animations/frontend-exporting.json'
  },
  height: '60vh',
  width: '60vw'
};
